import React, { useEffect } from 'react';
import EmiCalendar from './EmiCalendar';
import HeaderSection from './HeaderSection';
import { EMI_SCHEDULE_PARAM_KEYS } from 'src/pages/CaseDetails/constants/EmiSchedule.component';
import { useNavigate, useParams } from 'react-router-dom';
import { readQueryParams, createQueryParams } from 'src/utils/QueryParamsHelper';
import cx from 'classnames';
import styles from './index.module.scss';
import { addClickstreamEvent } from '../../../../service/clickStreamEventService';
import { CLICKSTREAM_EVENT_NAMES } from '../../../../service/clickStream.constant';
import { useSelector } from 'react-redux';
import { RootState } from '@cp/src/store';
import { createKey } from '@cp/src/utils/CaseDetail.utils';

const EmiSchedule = () => {
  const navigate = useNavigate();
  const { EMI_CALENDAR } = EMI_SCHEDULE_PARAM_KEYS;
  const { [EMI_CALENDAR]: queryParams } = readQueryParams();
  const updateQueryParamsAndNavigate = (params: { selectedChip: string }) => {
    const url = createQueryParams({ [EMI_CALENDAR]: { ...queryParams, ...params } });
    navigate(url, {
      replace: true
    });
  };

  const { loanId = '', customerId = '' } = useParams();

  const isPaused = useSelector(
    (state: RootState) =>
      state.caseDetail.pageData?.[createKey(loanId, customerId)]?.pause?.data?.isPaused
  );

  useEffect(() => {
    addClickstreamEvent(CLICKSTREAM_EVENT_NAMES.LH_EMISchedule_PageLand);
  }, []);

  return (
    <div
      className={cx(styles['emiScheduleContainer'], 'tabContentScroll', {
        tabContentScrollWithPausedCase: isPaused,
        'rr-block': true
      })}
    >
      <HeaderSection />
      <EmiCalendar
        queryParams={queryParams}
        updateQueryParamsAndNavigate={updateQueryParamsAndNavigate}
      />
    </div>
  );
};

export default EmiSchedule;
